import { Pullout, PulloutType } from '@aon/aon-tws-common-ui';
import React from 'react';
import HtmlParser from 'html-react-parser';
import ContentConstants from '../../../contentConstants';

export function QuestionHasUpdatesWarning() {
	return (
		<>
			<Pullout type={PulloutType.Warning}>{HtmlParser(ContentConstants.WARNING_QUESTION_HAS_UPDATES)}</Pullout>
		</>
	);
}
